import React from "react";

const Shimmer = ({ width, height = 14, radius = 8 }) => (
  <span className="rv-shimmer" style={{ width, height, borderRadius: radius }} />
);

export const ReviewCardSkeleton = () => (
  <li className="rv-card rv-card-skeleton" aria-hidden="true">
    <span className="rv-card-head">
      <Shimmer width={44} height={44} radius={16} />

      <span className="rv-card-identity">
        <Shimmer width="62%" height={14} />
        <Shimmer width="34%" height={12} />
      </span>
    </span>

    <span className="rv-card-rule" />

    <Shimmer width="46%" height={14} />
    <Shimmer width="100%" height={12} />
    <Shimmer width="78%" height={12} />
    <Shimmer width="40%" height={12} />
  </li>
);

export const ReviewCardsSkeleton = ({ cards = 6 }) => (
  <ul className="rv-list" aria-hidden="true">
    {Array.from({ length: cards }).map((unused, index) => (
      <ReviewCardSkeleton key={index} />
    ))}
  </ul>
);

export const TargetLineSkeleton = () => (
  <span className="rv-target-skeleton">
    <Shimmer width={120} height={12} />
  </span>
);

export default Shimmer;
